import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    state: String,
    categoryId: Number,
    month: String,
    session: Number
  }

  toggle(event) {
    event.preventDefault()

    const nextState = this.stateValue === "empty" ? "ok"
                    : this.stateValue === "ok"    ? "problem"
                    : this.stateValue === "problem" ? "in_progress"
                    : "empty"

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify({
        cell_state: {
          state: nextState,
          category_id: this.categoryIdValue,
          month: this.monthValue,
          session: this.sessionValue
        }
      })
    })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content
  }
}
